module.exports = __webpack_public_path__ + "img/Banner Cambio de precio.df60522b.png";